import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import EmailVerification from '../components/EmailVerification.js';

const mapStateToProps = (state) => {

    return {
        isLoading: state.users.isLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setIsLoading(loading) {
            if(loading){
                dispatch(submitForm());
            }else {
                dispatch(stopSubmitForm());
            }
        },
        throwNextStep(){
            dispatch(submitForm());
            dispatch(getNextStep()).then((result) => {
                    sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                    dispatch(stopSubmitForm());
                    browserHistory.push(result.payload.data.endpoint);
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailVerification);



/** WEBPACK FOOTER **
 ** ./src/containers/EmailVerificationContainer.js
 **/